import React, { useRef, useEffect } from 'react'

interface ThreeStateCheckboxProps {
    checked: boolean
    indeterminate: boolean
    onChange: () => void
    disabled?: boolean
}

export const ThreeStateCheckbox: React.FC<ThreeStateCheckboxProps> = ({
    checked,
    indeterminate,
    onChange,
    disabled = false,
}) => {
    const checkboxRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate
        }
    }, [indeterminate])

    // Define styles for the checkbox
    const checkboxStyle = {
        cursor: 'pointer',
        width: '18px',
        height: '18px',
        margin: 0,
        outline: 'none',
    }

    const disabledCheckboxStyle = {
        ...checkboxStyle,
        cursor: 'default',
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
                ref={checkboxRef}
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                style={disabled ? disabledCheckboxStyle : checkboxStyle}
            />
        </div>
    )
}
